import axios from "axios";
// import rootVm from '../main.js';

// 改用token方法后，貌似都不涉及跨域问题了
// let getCookie = function (cookie) {
//     let reg = /csrftoken=([\w]+)[;]?/g
//     return reg.exec(cookie)[1]
// }

const myaxios = axios.create({
    baseURL: "/",
    timeout: 500000,
})


// myaxios.interceptors.response.use(
//     response=>{
//         return response
//     },
//     error=>{
//         if(error){
//             console.log('error.response.status: ' + error.response.status);
//             if(error.response.status == 401){
//                 rootVm.$router.push({
//                     path: '/JKlogin'
//                 })
//             }
//         }
//         return Promise.reject(error)
//     }
// )
// myaxios.interceptors.request.use(
//   function(config) {
//     // 在post请求前统一添加X-CSRFToken的header信息，这里需要开启django middleware里的csrf功能
//     let cookie = document.cookie;
//     if(cookie && config.method == 'post'){
//       config.headers['X-CSRFToken'] = getCookie(cookie);
//     }
//     return config;
//   },
//   function(error) {
//     // Do something with request error
//     return Promise.reject(error);
//   }
// );

// myaxios.get('/data.json')
//     .then(resp => {
//         console.log(resp.data)
//     })
//     .catch(err => {
//         console.log("请求失败！")
//     })


export default myaxios;